import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "17.832",
  viewBox: "0 0 20 17.832"
}
const _hoisted_2 = {
  id: "Group_12",
  "data-name": "Group 12",
  transform: "translate(-812.292 -216.244)"
}
const _hoisted_3 = ["stroke"]
const _hoisted_4 = ["stroke"]

export interface Props {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckmarkIcon',
  props: {
    color: { default: "#000" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("line", {
        id: "Line_11",
        "data-name": "Line 11",
        x2: "5.108",
        y2: "5.855",
        transform: "translate(814.056 226.457)",
        fill: "none",
        stroke: _ctx.color,
        "stroke-linecap": "round",
        "stroke-width": "2.5"
      }, null, 8, _hoisted_3),
      _createElementVNode("line", {
        id: "Line_12",
        "data-name": "Line 12",
        x1: "11.373",
        y2: "14.312",
        transform: "translate(819.163 218)",
        fill: "none",
        stroke: _ctx.color,
        "stroke-linecap": "round",
        "stroke-width": "2.5"
      }, null, 8, _hoisted_4)
    ])
  ]))
}
}

})